module.exports = __webpack_public_path__ + "assets/rossette-failed.3443afc9.svg";